import styled from "styled-components";
import { StyledModal } from "../../../common/shared/modal.styled";

export const WrapperStyled = styled.div`
    .building-address {
        margin-inline-start: 10px;
        color: var(--bllink-purple);
    }
`

export const SetExpenseWrapperStyled = styled.div`
    border: 1px solid ${props => props.theme.borderLight};
    padding: 35px 32px;
    width: 100%;
    border-radius: 28px;
    margin-top: 80px;
    font-family: var(--bllink-font-primary);
    display: flex;
    gap: 50px;

    .set-expense-info {
        background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
        box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
        border-radius: 20px;
        padding: 39px 45px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 55px;
        width: 50%;

        .set-expense-title {
            font-weight: 700;
            font-size: 22px;
        }

        .building {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: fit-content;
            }
            .set-expense-subtitle {
                font-size: 16px;
                line-height: 25px;
                text-align: center;
                color: rgba(55, 54, 71, 0.7);
                margin-top: 35px;
            }
        }

        .app-btn {
            padding: 11px 20px;
            width: 200px;
            height: 44px;
        }
    }

    .set-expense-text {
        color: rgba(55, 54, 71, 0.7);
        width: 50%;

        .header {
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;           
            text-align: start;          
            margin: 25px auto 19px;
        }

        .subheader {
            margin-bottom: 10px;
            line-height: 22px;
            font-size: 14px;
        }

        .list-item {
            display: flex;
            gap: 12px;
            margin-bottom: 9px;
            font-size: 14px;
            line-height: 20px;

            img {
                align-self: start;
                margin-top: 7px;
            }

            .item-text {
                .item-header {
                    font-weight: 700;
                }
            }
        }
      
        .registration {
             border-top: solid 1px var(--bllink-border-light);
             margin-top: 42px;
             padding: 42px 160px;
             text-align: center;
             display: flex;
             flex-direction: column;
             align-items: center;
             gap: 28px;
             h3, a {
               color: var(--bllink-purple);
             }
             a {
               display: flex;
               align-items: center;
               justify-content: center;
               width: 204px;
               height: 44px;
               border: 1px solid var(--bllink-purple);
               border-radius: 50px;
             }
          
        }
    }
`

export const ConfirmLawyerLetterModalStyled = styled(StyledModal)`
    font-family: var(--bllink-font-primary);
    fontSize: 14px;

    .set-expense-title {
        font-weight: 400;
        font-size: 24px;
        line-height: 28px;   
        text-align: center;
        margin-top: 15px; 
        
        .building-title {
          font-weight: 700;
          color: var(--bllink-purple);
          margin-inline-start: 5px;  
        }
    }

    .modal-dialog {
        max-width: calc(100vw - 200px);

        .modal-close {
            top: 18px;
            color: #181818;
            opacity: 0.5;
        }

        .modal-content {
            background: #F9F9FF;
            box-shadow: -10px 48.5967px 140px rgba(126, 123, 160, 0.5);
            border-radius: 25px;
            border: none;

            .modal-body {
                margin-bottom: 30px;
                margin-right: 10px;
                padding: 50px 230px;
                direction: ltr;

                .modal-wrapper {
                    direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};
                }
                
                ::-webkit-scrollbar {
                    width: 1px;
                    visibility: hidden;
                }
                
                ::-webkit-scrollbar-thumb {
                    visibility: hidden;
                }
            }

            .dropdown-wrapper {
                width: 100%;
                direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};
                label {
                    margin-bottom: 8px !important;
                    font-size: 17px;
                    font-family: var(--bllink-font-primary);
                    color: rgba(55, 54, 71, 0.7);
                    font-weight: 700;
                }
            }

            .dropdown-wrapper.margin {               
                margin-bottom: 32px;
            }

            .input {
                margin-bottom: 31px;
                direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};

                label {
                    margin-bottom: 8px !important;
                    color: rgba(55, 54, 71, 0.7);
                    font-weight: 700;
                    font-size: 17px;
                }

                .bllink-input-border {
                    border: none;
                    border-bottom: 1px solid rgba(110, 116, 255, 0.4);
                    background-color: transparent;
                    border-radius: 0;
                    padding: 0;
                    font-size: 14px;
                    height: 30px;
                    margin-left: 2px;

                    ::placeholder {
                        color: rgba(55, 54, 71, 0.7);
                    }
                }
            }

            .frequency-months-wrapper {
                display: flex;  
                gap: 30px;

                .dropdown-wrapper {
                    width: 90%;
                }
                
                .frequency {
                    width: 100%;
                    margin-bottom: 34px;

                    .label {
                        margin-bottom: 16px;
                        color: rgba(55, 54, 71, 0.7);
                        font-weight: 700;
                        font-size: 17px;
                    }

                    .frequency-form {
                        display: flex;
                        gap: 32px;

                        .form-check {
                            margin: 0;
                            padding: 0;

                            .form-check-input {
                                margin: 0;
                                margin-inline-end: 12px;
                            }

                            input[type="radio"] {
                                display: none;
                            }
                              
                            input[type="radio"]+label {
                                position: relative;
                                padding-inline-start: 30px;
                                cursor: pointer;
                                color: rgba(55, 54, 71, 0.7);
                            }
                              
                            input[type="radio"]+label:before {
                                content: '';
                                border: 1px solid #6F8BFF;
                                height: 18px;
                                width: 18px;
                                border-radius: 50%;
                                position: absolute;
                                top: -2px;
                                left: ${(({ ltr }) => ltr ? '0' : '')};
                                right: ${(({ ltr }) => ltr ? '' : '0')};
                            }
                              
                            input[type="radio"]+label:after {
                                content: '';
                                background: #6F8BFF;
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                                position: absolute;
                                top: 3px;
                                left: ${(({ ltr }) => ltr ? '5px' : '')};
                                right: ${(({ ltr }) => ltr ? '' : '5px')};
                                opacity: 0;
                                transform: scale(2);
                                transition: transform 0.3s linear, opacity 0.3s linear;
                            }
                              
                            input[type="radio"]:checked+label:after {
                                opacity: 1;
                                transform: scale(1);
                            }
                        }
                    }
                }
            }

            .datepicker-wrapper {
                margin-bottom: 31px;
                direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};

                label {
                    color: rgba(55, 54, 71, 0.7);
                    font-weight: 700;
                    font-size: 17px;
                    margin-bottom: 8px !important;
                    text-align: start;
                }
            }

            .invoice-wrapper {
                display: flex;

                .input {
                    width: 80%;
                }

                .upload-invoice {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 17px;

                    input {
                        display: none;
                    }

                    .label {
                        color: rgba(55, 54, 71, 0.7);
                        font-weight: 700;
                        font-size: 17px;
                    }

                    .upload {
                        cursor: pointer;
                    }
                }
            }

            .uploaded-files {
                display: flex;
                gap: 11px;
                margin-bottom: 32px;
                flex-wrap: wrap;

                .uploaded-image {
                    position: relative;
                    width: fit-content;

                    .image {
                        height: 95px;
                        border: 1px solid rgba(110, 116, 255, 0.4);
                        border-radius: 11px;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        height: 100%;
                        width: 100%;
                        opacity: 0;
                        transition: .3s ease;
                        background-color: rgba(55, 54, 71, 0.7);
                        border-radius: 11px;
                        color: white;
                        padding: 3px 10px;
                        font-size: 40px;
                        cursor: pointer;

                        img {
                            margin-top: -35px;
                        }
                    }
                }

                .uploaded-image:hover .overlay {
                    opacity: 1;
                }

                .file-name {
                    color: rgba(55, 54, 71, 0.7);
                    font-size: 12px;
                    margin-top: 7px;
                }
            }

            .button-wrapper {
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 15px;
                align-items: center;
                margin-top: 100px;

                .app-btn {
                    width: 280px;
                }
            }

            .set-reccurent-payment {
                display: flex;
                flex-direction: column;
                align-items: center;

                .payment-method {
                    margin: 35px auto;
                }

                .transfer-coins-img {
                    margin-bottom: 55px;
                }

                .app-btn {
                    padding: 12px;
                    padding: 12px 0;
                    width: 150px;
                    min-width: unset;
                }

                .confirmation-info-wrapper {
                    display: flex;
                    gap: 100px;
                    margin: 35px auto 45px;
                    color: rgba(55, 54, 71, 0.7);
                    direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};

                    .confirmation-header {
                        font-weight: 700;
                        font-size: 17px;
                        margin-bottom: 10px;
                        text-align: start;
                    }

                    .confirmation-info {
                        font-size: 16px;
                        margin-bottom: 24px;
                        text-align: start;
                    }
                }
            }

            .set-one-time-payment {
                display: flex;
                flex-direction: column;
                align-items: center;

                .set-payment-info.margin {
                    margin-bottom: 35px;
                }

                .payment-method {
                    margin-bottom: 14px;
                }

                .app-btn {
                    margin-top: 40px;
                }

                .one-time-divider {
                    margin: 24px auto;
                    width: 100%;
                    max-width: 400px;
                    height: 1px;
                    background-color: #D8D2FF;
                }

                .input, .dropdown-wrapper {
                    width: 100%;
                    max-width: 500px;
                }
            }

            .set-payment-info {
                max-width: 350px;
                font-weight: 700;
                font-size: 22px;
                text-align: center;
                direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};

                .add-payment-highlithed {
                    color: var(--bllink-purple);
                }
            }

            .progress-line {
                display: flex;
                gap: 120px;
                margin-bottom: 30px;
                position: relative;
                direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};

                .divider-line {
                    position: absolute;
                    background-color: rgba(55, 54, 71, 0.1);
                    height: 2px;
                    width: 100px;
                    top: 30%;
                }

                .divider-line.colored {
                    background: linear-gradient(63.89deg, #6A92FF 17.04%, #8764FF 82.36%);
                }

                .divider-line.first {
                    left: ${(({ ltr }) => ltr ? '50px' : '')};
                    right: ${(({ ltr }) => ltr ? '' : '80px')};
                }

                .divider-line.second {
                    right: ${(({ ltr }) => ltr ? '50px' : '')};
                    left: ${(({ ltr }) => ltr ? '' : '80px')};
                }

                .divider-line-done-first, .divider-line-done-second {
                    position: absolute;
                    top: 30%;
                    background: linear-gradient(63.89deg, #6A92FF 17.04%, #8764FF 82.36%);
                    width: 50px;
                    height: 2px;
                }
                
                .divider-line-done-first {
                    left: ${(({ ltr }) => ltr ? '50px' : '')};
                    right: ${(({ ltr }) => ltr ? '' : '80px')};
                }

                .divider-line-done-second {
                    left: ${(({ ltr }) => ltr ? '' : '130px')};
                    right: ${(({ ltr }) => ltr ? '100px' : '')};
                }

                .step {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 4px;
                    font-weight: 700;
                    font-size: 12px;
                    color: rgba(55, 54, 71, 0.4);
                    text-transform: uppercase;
                    cursor: pointer;

                    .progress-step {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 28px;
                        height: 28px;
                        border-radius: 50px;
                        background-color: rgba(55, 54, 71, 0.1);
                        color: rgba(55, 54, 71, 0.4);
                        font-size: 10px;
                    }
                    
                    .progress-step.current {
                        background: linear-gradient(50.53deg, #6A92FF 20.83%, #8764FF 86.02%);
                    }

                    .current-text {
                        color: rgba(55, 54, 71, 0.7);
                    }
                }
            }

            .payment-method {
                background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
                box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
                border-radius: 11px;
                height: 70px;
                font-weight: 700;
                font-size: 17px;
                color: rgba(55, 54, 71, 0.7);
                width: 100%;
                max-width: 400px;
                cursor: pointer;
                display: grid;
                grid-template-columns: 1fr 5fr;
                padding: 15px 60px;
                direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};
                text-align: start;
                align-items: center;

                img {
                    margin-top: 3px;
                }

                .notice {
                    color: var(--bllink-purple);
                    font-size: 12px;
                }
            }

            .payment-method.bllink-method {
                align-items: start;
            }

            .payment-method.selected {
                border: 1px solid #6E74FF;
            }

            .payment-method-info {
                width: 100%;
                display: flex;
                margin: 35px auto 25px;
                gap: 20px;
                align-items: start;
                font-weight: 700;
                font-size: 14px;
                color: rgba(55, 54, 71, 0.7);
                max-width: 500px;
                direction: ${(({ ltr }) => ltr ? 'ltr' : 'rtl')};
                text-align: start;

                img {
                    margin-top: 3px;
                }

                .notice {
                    color: var(--bllink-purple);
                    font-size: 10px;
                    text-transform: uppercase;
                }
            }

            .datepicker-wrapper.select-payment {
                width: 100%;
                max-width: 500px;

                .react-datepicker-popper {
                    max-width: 500px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
`
